import * as Sentry from "@sentry/browser";

const RU_FEEDBACK = {
  triggerLabel: "Сообщить о проблеме",
  triggerAriaLabel: "Открыть форму обратной связи",
  formTitle: "Сообщить о проблеме",
  submitButtonLabel: "Отправить",
  cancelButtonLabel: "Отмена",
  confirmButtonLabel: "Подтвердить",
  nameLabel: "Имя",
  namePlaceholder: "Ваше имя",
  messageLabel: "Описание",
  messagePlaceholder:
    "Что произошло? Что вы ожидали увидеть? Какие шаги привели к проблеме?",
  successMessageText: "Спасибо! Сообщение отправлено.",
  isRequiredLabel: "(обязательно)",
} as const;

export function initSentry(dsn: string): void {
  Sentry.init({
    dsn,
    sendDefaultPii: true,
    integrations: [
      Sentry.feedbackIntegration({
        autoInject: false,
        showBranding: false,
        colorScheme: "light",
        showEmail: false,
        enableScreenshot: false,
        ...RU_FEEDBACK,
      }),
    ],
  });
}

export async function openFeedback(): Promise<void> {
  const feedback = Sentry.getFeedback();
  if (!feedback) {
    throw new Error("Sentry Feedback integration is not available");
  }

  const form = await feedback.createForm();
  form.appendToDom();
  form.open();
}
